import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, FeedEntry, Video } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityMeta, EntityMetaProps } from '@shapeable/ui';
const cls = classNames('feed-entry-meta');

// -------- Types -------->

// -------- Props -------->

export type VideoMetaProps = Classable & HasChildren & Omit<EntityMetaProps, 'fields'> & { 
  entity?: Video;
};

export const VideoMetaDefaultProps: Omit<VideoMetaProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(EntityMeta)<ContainerProps>`${ContainerStyles}`,
};

export const VideoMeta: Shapeable.FC<VideoMetaProps> = (props) => {
  const { className, children, entity } = props;
  
  return (
    <My.Container 
      entity={entity} 
      fields={[ 'published' ]} 
      className={cls.name(className)} 
    />
  )
};

VideoMeta.defaultProps = VideoMetaDefaultProps;
VideoMeta.cls = cls;